module.exports = __webpack_public_path__ + "static/media/LogoFooter.7df8d313.svg";